<cw-ci-data-table #plansDataTable
  tileTitle="Plans"
  addToolTip="Create a new plan"
  refreshToolTip="Reload plan list"
  defaultSortField="name"
  [isSelectable]="isSelectable"
  (loadItemsHandler)="loadPlans($event)"
  (addHandler)="addPlan($event)"
  (selectHandler)="editPlan($event)"
  [items]="plansList">

  <cw-ci-table-column columnName="active" columnTitle="Active" [output]="activeTemplate" searchField="active" filterType="select" [filterOptions]="[{display:'Active', value:'true'}, {display:'Inactive', value:'false'}]"></cw-ci-table-column>
  <ng-template let-element #activeTemplate><mat-icon color="accent" *ngIf="element.isActive">check</mat-icon></ng-template>

  <cw-ci-table-column columnName="id" columnTitle="Id" sortField="id"></cw-ci-table-column>
  <cw-ci-table-column columnName="name" columnTitle="Name" sortField="name"></cw-ci-table-column>
  <cw-ci-table-column columnName="trialPeriodDays" columnTitle="Trial Period Days" sortField="trial_period_days"></cw-ci-table-column>

  <cw-ci-table-column columnName="public" columnTitle="Public" [output]="publicTemplate" searchField="public" filterType="select" [filterOptions]="[{display:'Public', value:'true'}, {display:'Private', value:'false'}]"></cw-ci-table-column>
  <ng-template let-element #publicTemplate><mat-icon color="accent" *ngIf="element.isPublic">check</mat-icon></ng-template>

  <cw-ci-table-column columnName="externalProduct" columnTitle="External Product"></cw-ci-table-column>

  <cw-ci-table-column columnName="updatedAt" columnTitle="Updated" sortField="updated_at" [output]="updatedAtTemplate"></cw-ci-table-column>
  <ng-template let-element #updatedAtTemplate>{{element.updatedAt | date:'mediumDate':'+0000'}}</ng-template>

  <cw-ci-table-column columnName="actions" columnTitle="Actions" [output]="actionTemplate"></cw-ci-table-column>
  <ng-template let-element #actionTemplate>
    <cw-ci-table-column-action actionToolTip="Edit the plan" svgIcon="cw:action_edit" actionColor="primary" [element]="element" (clickHandler)="editPlan($event)"></cw-ci-table-column-action>

    <cw-ci-table-column-action [visible]="element.isActive" actionToolTip="Deactivate the plan" matIcon="delete" actionColor="primary" [element]="element" (clickHandler)="deletePlan($event)"></cw-ci-table-column-action>
    <cw-ci-table-column-action [visible]="!element.isActive" actionToolTip="Delete the plan" matIcon="delete_forever" actionColor="warn" [element]="element" (clickHandler)="deletePlan($event)"></cw-ci-table-column-action>
  </ng-template>

</cw-ci-data-table>
